import { render, staticRenderFns } from "./SuppliersManagment.vue?vue&type=template&id=14d3da7b&scoped=true&lang=pug&"
import script from "./SuppliersManagment.vue?vue&type=script&lang=ts&"
export * from "./SuppliersManagment.vue?vue&type=script&lang=ts&"
import style0 from "./SuppliersManagment.vue?vue&type=style&index=0&id=14d3da7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d3da7b",
  null
  
)

export default component.exports